import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TwoFactorIcon from 'react-icons/lib/md/lock'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import {Link} from 'react-router'

@withGraphQL(gql`
  query getMyTwoFactor {
    me {
      _id
      hasTwoFactor
    }
  }
`)
export default class TwoFactor extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    me: PropTypes.func
  }

  @autobind
  onChange(event) {
    if (!/^[0-9]*$/.test(event.target.value)) return this.props.onChange(this.props.value)
    this.props.onChange(event.target.value)
  }

  renderAddTwoFactor() {
    return (
      <div className={styles.addTwoFactor}>
        <Link to="/settings/security">
          <Tooltip content="Configura la autentificación de dos factores">
            <TwoFactorIcon size={22} />
            <div className={styles.text}>
              Requiere autentificación<br />de dos factores
            </div>
          </Tooltip>
        </Link>
      </div>
    )
  }

  render() {
    if (!this.props.me.hasTwoFactor) return this.renderAddTwoFactor()
    return (
      <div className={styles.container} onClick={() => this.input.focus()}>
        <div className={styles.icon}>
          <Tooltip content="Autentificación de dos factores">
            <TwoFactorIcon size={22} />
          </Tooltip>
        </div>
        <input
          ref={input => {
            this.input = input
          }}
          maxLength={6}
          type="text"
          value={this.props.value}
          onChange={this.onChange}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/TwoFactor/index.js